import type { DataResponse, PaginatedResponse, Tool, ToolCreate, ToolSummary, ToolUpdate } from "@/types";
import { api } from "../api";

export const toolService = {
  list: (params?: { page?: number; pageSize?: number; toolType?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.toolType) searchParams.set("tool_type", params.toolType);
    return api.get<PaginatedResponse<ToolSummary>>(`/tools?${searchParams}`);
  },

  get: (uuid: string) => api.get<DataResponse<Tool>>(`/tools/${uuid}`),

  create: (data: ToolCreate) => api.post<DataResponse<Tool>>("/tools", data),

  update: (uuid: string, data: ToolUpdate) => api.put<DataResponse<Tool>>(`/tools/${uuid}`, data),

  delete: (toolUuid: string) => api.delete(`/tools/${toolUuid}`),
};
